module.exports = __webpack_public_path__ + "cc62f7d865122094b1a0643076f20b6f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/Entwicklung_Steuerbelastung_2017-2007-desktop.svg
// module id = 763
// module chunks = 1